import axios from "axios";
export default {
    createSummaryReportObjects: (data, summaryReportIds) => axios.post("/SummaryReports/CreateSummaryReportObjects", {
        SummaryReportObject: data,
        SummaryReportIds: summaryReportIds
    })
};
